const it: Record<string, string> = {
  "Virtual Try-On": "Prova Virtuale",
  "Find Your Size & See It On You": "Trova la tua taglia e provalo",
  "See Your Fit": "Vedi la vestibilità",
  "Check your size, then try it on virtually": "Controlla la tua taglia, poi provalo virtualmente",
  "Get Your Size": "La tua taglia",
  "Instant fit suggestion": "Suggerimento vestibilità istantaneo",
  "Try It On": "Provalo",
  "See how it looks on you": "Guarda come ti sta",
  "Find My Size": "Trova la mia taglia",
  "Takes less than a minute": "Richiede meno di un minuto",
  "Upload a full body photo": "Carica una foto a figura intera",
  "JPEG, PNG or WebP (max 10MB)": "JPEG, PNG o WebP (max 10MB)",
  "Your photo": "La tua foto",
  "Let's find your best fit": "Troviamo la tua vestibilità ideale",
  "Centimeters": "Centimetri",
  "Inches": "Pollici",
  "Load saved profile...": "Carica profilo salvato...",
  "HEIGHT": "ALTEZZA",
  "WEIGHT": "PESO",
  "feet": "piedi",
  "inches": "pollici",
  "cm": "cm",
  "kg": "kg",
  "lbs": "libbre",
  "in": "poll",
  "How to measure": "Come misurare",
  "Hide guide": "Nascondi guida",
  "I know my measurements": "Conosco le mie misure",
  "Not sure? Use height & weight instead": "Non sei sicuro? Usa altezza e peso",
  "Please fill in height and weight": "Inserisci altezza e peso",
  "Please fill in all required fields": "Compila tutti i campi obbligatori",
  "Next": "Avanti",
  "Analyzing your size...": "Analisi della tua taglia...",
  "SUGGESTED SIZE": "TAGLIA SUGGERITA",
  "NOT SUGGESTED": "NON SUGGERITA",
  "Edit measurements": "Modifica misure",
  "Size guide": "Guida alle taglie",
  "Your fit": "La tua vestibilità",
  "Your Suggested Size": "La tua taglia suggerita",
  "Your measure": "La tua misura",
  "within range": "entro l'intervallo",
  "too tight": "troppo stretto",
  "tight": "stretto",
  "a bit tight": "un po' stretto",
  "too loose": "troppo largo",
  "loose": "largo",
  "a bit loose": "un po' largo",
  "See fit on your photo": "Vedi vestibilità sulla tua foto",
  "Hide visual fit": "Nascondi vestibilità visiva",
  "Analyzing...": "Analisi...",
  "Try it on": "Provalo",
  "SIZE CHART": "TABELLA TAGLIE",
  "YOUR ESTIMATED MEASUREMENTS": "LE TUE MISURE STIMATE",
  "Edit": "Modifica",
  "Download": "Scarica",
  "Size chart": "Tabella taglie",
  "Preparing your image...": "Preparazione dell'immagine...",
  "Analyzing body proportions...": "Analisi delle proporzioni corporee...",
  "Matching garment to your photo...": "Adattamento del capo alla tua foto...",
  "Generating virtual try-on...": "Generazione della prova virtuale...",
  "Refining details...": "Rifinitura dei dettagli...",
  "Almost there...": "Quasi pronto...",
  "Complete!": "Completato!",
  "This usually takes 15-25 seconds": "Di solito richiede 15-25 secondi",
  "Something went wrong": "Qualcosa è andato storto",
  "Try Again": "Riprova",
  "We couldn't find a matching size for you": "Non abbiamo trovato una taglia adatta a te",
  "Please try the manual measurement screen so we can calculate your fit from your measurements.": "Prova la schermata delle misure manuali così possiamo calcolare la vestibilità dalle tue misure.",
  "Try manual measurements": "Prova misure manuali",
  "SDK not configured. Please provide an API key.": "SDK non configurato. Fornisci una chiave API.",
  "Please upload a JPEG, PNG, or WebP image.": "Carica un'immagine JPEG, PNG o WebP.",
  "Image must be under 10MB.": "L'immagine deve essere inferiore a 10MB.",
  "Try-on generation failed": "Generazione della prova fallita",
  "Failed to start try-on": "Impossibile avviare la prova",
  "No product image found. Please set the product-image attribute.": "Nessuna immagine prodotto trovata. Imposta l'attributo product-image.",
  "Powered by": "Powered by",
  "My Profiles": "I miei Profili",
  "History": "Cronologia",
  "No saved profiles yet.": "Nessun profilo salvato.",
  "No history yet.": "Nessuna cronologia.",
  "Product": "Prodotto",
  "Women's": "Donna",
  "Men's": "Uomo",
  "Profiles": "Profili",
  "Women's Profile": "Profilo Donna",
  "Men's Profile": "Profilo Uomo",
  "Height": "Altezza",
  "Weight": "Peso",
  "Chest": "Petto",
  "Bust": "Busto",
  "Waist": "Vita",
  "Hips": "Fianchi",
  "Shoulders": "Spalle",
  "Sleeve": "Manica",
  "Inseam": "Cavallo",
  "Neck": "Collo",
  "Foot": "Piede",
  "Shoe EU": "Scarpa EU",
  "Shoe US": "Scarpa US",
  "Shoe UK": "Scarpa UK",
  "Saved": "Salvato",
  "Delete Profile": "Elimina Profilo",
  "Shoe size (US)": "Numero di scarpa (US)",
  "Shoe size (UK)": "Numero di scarpa (UK)",
  "Shoe size (EU)": "Numero di scarpa (EU)",
  "Generating...": "Generazione...",
  "Foot length": "Lunghezza del piede",
  "Size": "Taglia",
  "Try on size": "Prova la taglia",
  "e.g.": "es.",
  "Drop your photo here or click to upload": "Trascina la foto qui o clicca per caricare",
  "This usually takes 15-20 seconds": "Di solito richiede 15-20 secondi",
  "Try-on result": "Risultato della prova",
  "Try Another": "Prova un'altra",
  "Back": "Indietro",
  "You": "Tu",
  "Garment": "Capo",
  "Your Height": "La Tua Altezza",
  "Your Weight": "Il Tuo Peso",
  "Drag or scroll to set your height": "Trascina o scorri per impostare la tua altezza",
  "Drag or scroll to set your weight": "Trascina o scorri per impostare il tuo peso",
  "Enter height and weight first": "Inserisci prima altezza e peso",

  // ── Field labels ──
  "Lens Width": "Larghezza lente",
  "Bridge": "Ponte",
  "Arm Length": "Lunghezza asta",
  "Head Circumference": "Circonferenza testa",
  "Face Width": "Larghezza viso",
  "Temple": "Asta",
  "Around widest point": "Intorno al punto più largo",
  "Foot Length": "Lunghezza del piede",
  "Shoulder": "Spalla",
  "Thigh": "Coscia",
  "Hip": "Fianco",

  // ── Units ──
  "Millimetre": "Millimetro",
  "Centimetre": "Centimetro",
  "Millimeters": "Millimetri",

  // ── Fit descriptors ──
  "Tight": "Stretto",
  "Loose": "Largo",
  "Short": "Corto",
  "Long": "Lungo",
  "✓ Fit": "✓ Adatto",
  "too short": "troppo corto",
  "too long": "troppo lungo",
  "a bit short": "un po' corto",
  "a bit long": "un po' lungo",

  // ── Length pills ──
  "Length": "Lunghezza",
  "Length Adjustment": "Regolazione lunghezza",
  "Regular": "Regolare",
  "Big": "Grande",
  "Big & Tall": "Grande & Alto",

  // ── Misc ──
  "preview": "anteprima",

  // ── BodyProfileView — photo upload area (left section) ──
  "Upload your photo": "Carica la tua foto",
  "Upload a photo": "Carica una foto",
  "Click or drag a full-body photo": "Clicca o trascina una foto a figura intera",
  "Or upload a photo for AI sizing": "Oppure carica una foto per l'analisi AI",
  "Photo": "Foto",
  "How to take a good photo": "Come scattare una buona foto",
  "How to take the best photo": "Come scattare la foto migliore",
  "Do": "Da fare",
  "Don't": "Da evitare",
  "Quick Tip": "Suggerimento rapido",
  "The simpler your photo is, the more accurate your virtual try-on results will be.": "Più la foto è semplice, più accurati saranno i risultati della prova virtuale.",
  "Choose a plain background (a light wall is ideal)": "Scegli uno sfondo semplice (una parete chiara è ideale)",
  "Stand facing the camera with your full body in frame": "Mettiti di fronte alla fotocamera con tutto il corpo nell'inquadratura",
  "Stand straight and still, arms relaxed by your sides": "Stai dritto e fermo, con le braccia rilassate lungo i fianchi",
  "Stand with your HEELS against a wall for best accuracy": "Appoggia i TALLONI a un muro per la massima precisione",
  "Use natural or even lighting (e.g. near a window)": "Usa luce naturale o uniforme (es. vicino a una finestra)",
  "Wear fitted, simple clothing (e.g. neutral colors)": "Indossa abiti aderenti e semplici (es. colori neutri)",
  "Don't wear loose, baggy, or layered clothing": "Non indossare abiti larghi, ampi o a strati",
  "Don't sit, pose, or bend your body": "Non sederti, non posare e non piegare il corpo",
  "Don't use strong backlighting": "Non usare forte controluce",
  "Don't take mirror photos or selfies": "Non scattare foto allo specchio o selfie",
  "Don't apply filters, effects, or edits": "Non applicare filtri, effetti o modifiche",

  // ── Age gate ──
  "Are you 18 or older?": "Hai 18 anni o più?",
  "Yes": "Sì",
  "No": "No",
  "Please confirm your age": "Per favore conferma la tua età",
  "Please confirm that the person in the photo is 18 or older before uploading.": "Conferma che la persona nella foto ha 18 anni o più prima di caricarla.",
  "Under 18 — can't process this photo.": "Meno di 18 anni — impossibile elaborare questa foto.",
  "This photo appears to be of a minor. Please upload a photo of someone 18 or older.": "Questa foto sembra ritrarre un minore. Carica la foto di una persona di 18 anni o più.",
  "Different photo needed": "È necessaria un'altra foto",
  "Try another photo": "Prova un'altra foto",

  // ── Photo step controls ──
  "Continue": "Continua",
  "Analyze My Size": "Analizza la mia taglia",
  "Analyzing photo…": "Analisi della foto…",
  "Details": "Dettagli",
  "Image must be under 10MB": "L'immagine deve essere inferiore a 10 MB",
  "Please upload an image file": "Carica un file immagine",
  "Please upload a photo": "Carica una foto",
  "Prefer not to upload a photo?": "Preferisci non caricare una foto?",
  "Enter measurements manually": "Inserisci le misure manualmente",
  "Legal Notice": "Avviso legale",
  "Your image will be used to generate a virtual try-on preview showing how selected items may look and fit. Images are processed securely and are not stored after generation.": "La tua immagine verrà utilizzata per generare un'anteprima della prova virtuale che mostra come gli articoli selezionati possono apparire e calzare. Le immagini sono elaborate in modo sicuro e non vengono archiviate dopo la generazione.",

  // ── BodyProfileView — form (right section) ──
  "Body details": "Dettagli corporei",
  "Your body details": "I tuoi dettagli corporei",
  "Body Measurements": "Misure corporee",
  "AGE": "ETÀ",
  "years": "anni",
  "Enter your height": "Inserisci la tua altezza",
  "Enter your weight": "Inserisci il tuo peso",
  "Enter your bra size": "Inserisci la taglia del reggiseno",
  "Please enter your height": "Inserisci la tua altezza",
  "Please enter your weight": "Inserisci il tuo peso",
  "Please enter a valid height": "Inserisci un'altezza valida",
  "Please enter a valid weight": "Inserisci un peso valido",
  "Please enter a valid height (100-250 cm)": "Inserisci un'altezza valida (100-250 cm)",
  "Please enter a valid weight (30-300 kg)": "Inserisci un peso valido (30-300 kg)",
  "Please select both band and cup size": "Seleziona sia la circonferenza che la coppa",
  "Select your bra size": "Seleziona la taglia del reggiseno",
  "BAND": "FASCIA",
  "BAND SIZE": "MISURA FASCIA",
  "CUP": "COPPA",
  "CUP SIZE": "MISURA COPPA",
  "BRA REGION": "REGIONE REGGISENO",
  "Imperial": "Imperiale",
  "Metric": "Metrico",
  "These calibrate the AI — all required.": "Questi calibrano l'IA — tutti obbligatori.",
  "Using": "In uso",
  "start fresh": "ricomincia",
  "Close": "Chiudi",

  // ── Body shape questions ──
  "Which best describes your chest?": "Quale descrive meglio il tuo petto?",
  "WHICH BEST DESCRIBES YOUR CHEST?": "QUALE DESCRIVE MEGLIO IL TUO PETTO?",
  "Which best describes your hips?": "Quale descrive meglio i tuoi fianchi?",
  "WHICH BEST DESCRIBES YOUR HIPS?": "QUALE DESCRIVE MEGLIO I TUOI FIANCHI?",
  "Which best describes your midsection?": "Quale descrive meglio la tua vita?",
  "WHICH BEST DESCRIBES YOUR MIDSECTION?": "QUALE DESCRIVE MEGLIO LA TUA VITA?",
  "Which best describes your seat?": "Quale descrive meglio il tuo lato B?",
  "WHICH BEST DESCRIBES YOUR SEAT?": "QUALE DESCRIVE MEGLIO IL TUO LATO B?",
  "Average": "Media",
  "Narrow": "Stretto",
  "Broad": "Ampio",
  "Curvy": "Curvilineo",
  "A slimmer, narrower chest build": "Un petto più snello e stretto",
  "A moderate, proportionate chest": "Un petto moderato e proporzionato",
  "A wider, more muscular chest": "Un petto più ampio e muscoloso",
  "A flatter midsection with minimal protrusion": "Una vita più piatta con minima protrusione",
  "A moderate, natural midsection shape": "Una vita moderata e naturale",
  "A fuller, more rounded midsection": "Una vita più piena e arrotondata",
  "A flatter backside with less projection": "Un lato B più piatto e meno proiettato",
  "A moderate, natural backside shape": "Un lato B moderato e naturale",
  "A fuller, more rounded backside": "Un lato B più pieno e arrotondato",

  // ── Photo step — profile photo preload pill ──
  "Loaded from profile": "Caricata dal profilo",
  "Clear": "Cancella",
};
export default it;
